import { Navigate, useLocation } from 'react-router';

/**
 * Redirect that keeps the query string and hash. Job boards link to old hub paths with
 * `?jobId=`, and a plain `<Navigate to>` would drop it before the start page can read it.
 */
export function RedirectKeepingQuery({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
